import { GaugeBase } from 'app/shared/elements/gauges/gauge-base';
import { bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@bindable.number({ name: 'value' })
@bindable.string({ name: 'label' })
@bindable.stringNull({ name: 'color' })
@bindable.number({ name: 'min' })
@bindable.number({ name: 'max' })
@bindable.number({ name: 'precision' })
export class EssBarGaugeCustomElement extends GaugeBase { }
